import { css } from '@emotion/react';
import { font, FontSizeName, FontWeightName } from './font';

export const textStyle = (size: FontSizeName, weight: FontWeightName) => {
  return css`
    font-size: ${font.size[size]}px;
    font-weight: ${font.weight[weight]};
  `;
};
